<template>
  <div :class="_class">
    <slot></slot>
  </div>
</template>

<script>
  const name = 'hive-timeline';

  export default {
    name,
    computed: {
      _class() {
        return [
          name,
        ];
      },
    },
  };
</script>
